module.exports = __webpack_public_path__ + "img/ic_email_nor-1.c8227881.svg";